import { HiPlus } from '@react-icons/all-files/hi/HiPlus';
import { Carousel, Collapse } from 'antd';
import classNames from 'classnames';
import Image from 'next/image';
import type React from 'react';

import './faq-block.scss';

import faqBg from '~/assets/backgrounds/faq-bg.webp';

const FaqBlock = ({ t }) => {
  const getItems = ({ panelStyle }) => [
    [
      {
        key: '1',
        itemProp: 'mainEntity',
        itemScope: true,
        itemType: 'https://schema.org/Question',
        label: <div itemProp="name">{t('text.faq-how-match-time')}</div>,
        children: (
          <div itemProp="acceptedAnswer" itemScope itemType="http://schema.org/Answer">
            <p itemProp="text">{t('text.faq-how-match-time-description')}</p>
            <a
              target="_self"
              itemProp="url"
              className="link link--underlined"
              href="https://prana-club.com/posts/yak-vivchiti-z-ditinoyu-bukvi"
            >
              {t('button.more')}
            </a>
          </div>
        ),
        style: panelStyle,
      },
      {
        key: '2',
        itemProp: 'mainEntity',
        itemScope: true,
        itemType: 'https://schema.org/Question',
        label: t('text.how-to-teach-a-child-to-form-syllables'),
        children: (
          <div itemProp="acceptedAnswer" itemScope itemType="http://schema.org/Answer">
            <p itemProp="text">{t('text.how-to-teach-a-child-to-form-syllables-description')}</p>
            <a
              itemProp="url"
              target="_self"
              className="link link--underlined"
              href="https://prana-club.com/posts/yak-navchiti-ditinu-formuvati-skladi"
            >
              {t('button.more')}
            </a>
          </div>
        ),
        style: panelStyle,
      },
      {
        key: '3',
        itemProp: 'mainEntity',
        itemScope: true,
        itemType: 'https://schema.org/Question',
        label: t('text.my-child-is-confusing-letters-what-to-do'),
        children: (
          <div itemProp="acceptedAnswer" itemScope itemType="http://schema.org/Answer">
            <p itemProp="text">{t('text.my-child-is-confusing-letters-what-to-do-description')}</p>
            <a
              itemProp="url"
              target="_self"
              className="link link--underlined"
              href="https://prana-club.com/posts/dytyna-plutaie-bukvy-shcho-robyty"
            >
              {t('button.more')}
            </a>
          </div>
        ),
        style: panelStyle,
      },
      {
        key: '4',
        itemProp: 'mainEntity',
        itemScope: true,
        itemType: 'https://schema.org/Question',
        label: t('text.how-to-develop-memory-in-a-child'),
        children: (
          <div itemProp="acceptedAnswer" itemScope itemType="http://schema.org/Answer">
            <p itemProp="text">{t('text.how-to-develop-memory-in-a-child-description')}</p>
            <a
              itemProp="url"
              target="_self"
              className="link link--underlined"
              href="https://prana-club.com/posts/pam-yat-ta-shcho-na-neyi-vplivaie-i-yak-rozvinuti"
            >
              {t('button.more')}
            </a>
          </div>
        ),
        style: panelStyle,
      },
    ],
    [
      {
        key: '1',
        itemProp: 'mainEntity',
        itemScope: true,
        itemType: 'https://schema.org/Question',
        label: <div itemProp="name">{t('text.how-to-motivate-a-child-to-read')}</div>,
        children: (
          <div itemProp="acceptedAnswer" itemScope itemType="http://schema.org/Answer">
            <p itemProp="text">{t('text.how-to-motivate-a-child-to-read-description')}</p>
            <a
              target="_self"
              itemProp="url"
              className="link link--underlined"
              href="https://prana-club.com/posts/10-porad-yak-motyvuvaty-dytynu-chytaty"
            >
              {t('button.more')}
            </a>
          </div>
        ),
        style: panelStyle,
      },
      {
        key: '2',
        itemProp: 'mainEntity',
        itemScope: true,
        itemType: 'https://schema.org/Question',
        label: t('text.reading-or-speed-reading-which-is-better-for-a-child'),
        children: (
          <div itemProp="acceptedAnswer" itemScope itemType="http://schema.org/Answer">
            <p itemProp="text">{t('text.reading-or-speed-reading-which-is-better-for-a-child-description')}</p>
            <a
              itemProp="url"
              target="_self"
              className="link link--underlined"
              href="https://prana-club.com/posts/chytannya-chy-shvydkochytannya"
            >
              {t('button.more')}
            </a>
          </div>
        ),
        style: panelStyle,
      },
      {
        key: '3',
        itemProp: 'mainEntity',
        itemScope: true,
        itemType: 'https://schema.org/Question',
        label: t('text.at-what-age-should-you-start-teaching-a-child-to-read'),
        children: (
          <div itemProp="acceptedAnswer" itemScope itemType="http://schema.org/Answer">
            <p itemProp="text">{t('text.at-what-age-should-you-start-teaching-a-child-to-read-description')}</p>
            <a
              itemProp="url"
              target="_self"
              className="link link--underlined"
              href="https://prana-club.com/posts/z-yakoho-viku-dytynu-navchaty-chytaty"
            >
              {t('button.more')}
            </a>
          </div>
        ),
        style: panelStyle,
      },
      {
        key: '4',
        itemProp: 'mainEntity',
        itemScope: true,
        itemType: 'https://schema.org/Question',
        label: t('text.how-to-make-learning-to-read-interesting'),
        children: (
          <div itemProp="acceptedAnswer" itemScope itemType="http://schema.org/Answer">
            <p itemProp="text">{t('text.how-to-make-learning-to-read-interesting-description')}</p>
            <a
              itemProp="url"
              target="_self"
              className="link link--underlined"
              href="https://prana-club.com/posts/yak-zrobyty-navchannya-chytannyu-tsikavym"
            >
              {t('button.more')}
            </a>
          </div>
        ),
        style: panelStyle,
      },
    ],
    [
      {
        key: '1',
        itemProp: 'mainEntity',
        itemScope: true,
        itemType: 'https://schema.org/Question',
        label: <div itemProp="name">{t('text.how-to-make-the-process-effective-when-teaching-reading')}</div>,
        children: (
          <div itemProp="acceptedAnswer" itemScope itemType="http://schema.org/Answer">
            <p itemProp="text">{t('text.how-to-make-the-process-effective-when-teaching-reading-description')}</p>
            <a
              target="_self"
              itemProp="url"
              className="link link--underlined"
              href="https://prana-club.com/posts/pomylky-batkiv-pry-navchanni-chytannyu"
            >
              {t('button.more')}
            </a>
          </div>
        ),
        style: panelStyle,
      },
      {
        key: '2',
        itemProp: 'mainEntity',
        itemScope: true,
        itemType: 'https://schema.org/Question',
        label: t('text.how-to-avoid-overexertion-when-learning-to-read'),
        children: (
          <div itemProp="acceptedAnswer" itemScope itemType="http://schema.org/Answer">
            <p itemProp="text">{t('text.how-to-avoid-overexertion-when-learning-to-read-description')}</p>
            <a
              itemProp="url"
              target="_self"
              className="link link--underlined"
              href="https://prana-club.com/posts/unyknuty-perevtomy-pry-chytanni"
            >
              {t('button.more')}
            </a>
          </div>
        ),
        style: panelStyle,
      },
      {
        key: '3',
        itemProp: 'mainEntity',
        itemScope: true,
        itemType: 'https://schema.org/Question',
        label: t('text.why-does-a-child-read-slowly-and-how-to-fix-it'),
        children: (
          <div itemProp="acceptedAnswer" itemScope itemType="http://schema.org/Answer">
            <p itemProp="text">{t('text.why-does-a-child-read-slowly-and-how-to-fix-it-description')}</p>
            <a
              itemProp="url"
              target="_self"
              className="link link--underlined"
              href="https://prana-club.com/posts/dytyna-chytaie-povilno-yak-tse-vypravyty"
            >
              {t('button.more')}
            </a>
          </div>
        ),
        style: panelStyle,
      },
      {
        key: '4',
        itemProp: 'mainEntity',
        itemScope: true,
        itemType: 'https://schema.org/Question',
        label: t('text.audiobooks-for-children-do-they-help-or-hinder-learning-to-read'),
        children: (
          <div itemProp="acceptedAnswer" itemScope itemType="http://schema.org/Answer">
            <p itemProp="text">
              {t('text.audiobooks-for-children-do-they-help-or-hinder-learning-to-read-description')}
            </p>
            <a
              itemProp="url"
              target="_self"
              className="link link--underlined"
              href="https://prana-club.com/posts/audioknyhy-dlya-ditei-navchytysya-chytaty"
            >
              {t('button.more')}
            </a>
          </div>
        ),
        style: panelStyle,
      },
    ],
  ];

  const panelStyle: React.CSSProperties = {
    background: '#FAF9F8',
  };

  const onChange = (key: string | string[]) => {
    console.info(key);
  };

  const onPageChange = (currentSlide: number) => {
    console.info(currentSlide);
  };

  return (
    <div
      aria-hidden="true"
      itemScope
      itemType="https://schema.org/FAQPage"
      id="faq"
      className={classNames('container', 'faq-block')}
    >
      <Image
        loading="lazy"
        priority={false}
        alt={t('text.faq-block')}
        title={t('text.faq-block')}
        src={faqBg.src}
        width={492}
        height={465}
        className="faq-block__bg-image"
      />
      <div className="faq-block__rows">
        <h3 className="faq-block__title">{t('text.faq-block')}</h3>
        <Carousel afterChange={onPageChange}>
          {[...Array(3).keys()]?.map((item, i) => {
            return (
              <Collapse
                className="faq-block__accordion"
                accordion
                key={item}
                expandIcon={({ isActive }) => (
                  <HiPlus
                    size={20}
                    className={classNames({
                      'faq-block__item-icon--active': isActive ? 45 : 0,
                    })}
                  />
                )}
                items={getItems({ panelStyle })?.[i]}
                defaultActiveKey={['1']}
                onChange={onChange}
              />
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};

export default FaqBlock;
